import ApiKeyTable from "@/app/app-shared/api-key/table";

export default function ApiKeyPage() {
  return (
    <>
      <ApiKeyTable />
    </>
  );
}
